import React, { useEffect, useState } from 'react'
import { Modal, Button, Loader, Message, Row } from 'rsuite'
import ApproverListDetail from './ApproverListDetail'
import CancelButton from '../../buttons/cancelButton/CancelButton'
import ViewButton from '../../buttons/viewButton/ViewButton'
import { getCheckApprover, getFetchNew } from '../../../redux/actions/approveProject'
import notification from '../../../utils/notification'
import SaveButton from '../../buttons/saveButton/SaveButton'
import { doneLoading, startLoading } from '../../../utils/loading'
import ConfirmWidget from '../../../widgets/confirm/ConfirmWidget'
import { RETRY_CONTACT_ADMIN } from '../../../constants/msgText'
import OverlayLoader from '../../OverlayLoader/OverlayLoader'

const FetchNewApprover = ({
  approveType,
  projectversionId,
  buttontext,
  onSuccess,
  requestId,
  style,
  disabled
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isShowConf, setIsShowConf] = useState()
  console.log('style===>', style)

  const onNewApprover = async () => {
    setIsShowConf(false)
    let request = {
      approveType: approveType,
      projectversionId: projectversionId,
    }
    console.log('request===>', request)
    console.log('onNewApprover+isShowConf===>', isShowConf)
    handleNewApprover(request)
  }

  const handleNewApprover = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getFetchNew(request.projectversionId, request.approveType,requestId)
      if (response.success == true) {
        onSuccess()
        notification.open('success', {
          title: 'ส่งสำเร็จ',
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: response.message || response.errorMessage,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || RETRY_CONTACT_ADMIN,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      {isLoading && <OverlayLoader />}
      <SaveButton
        style={style}
        icon="send-o"
        onClick={() => {
          setIsShowConf(true)
        }}
        disabled={disabled}
      >
        {buttontext || 'ส่งเสนอขออนุมัติ'}
      </SaveButton>

      <ConfirmWidget
        title={''}
        show={isShowConf}
        size="sm"
        detail={<div style={{ marginTop: 10, paddingTop: -10 }}>ยืนยันการขอสายใหม่</div>}
        onCancle={() => setIsShowConf(false)}
        onConfirm={onNewApprover}
      />
    </>
  )
}

export default FetchNewApprover
